import ApiKeyService from 'src/modules/apiKey/apiKeyService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'APIKEY_FORM';

const apiKeyFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: apiKeyFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await ApiKeyService.find(id);
      }

      dispatch({
        type: apiKeyFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: apiKeyFormActions.INIT_ERROR,
      });

      getHistory().push('/api-key');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: apiKeyFormActions.CREATE_STARTED,
      });

      await ApiKeyService.create(values);

      dispatch({
        type: apiKeyFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.apiKey.create.success'),
      );

      getHistory().push('/api-key');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: apiKeyFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: apiKeyFormActions.UPDATE_STARTED,
      });

      await ApiKeyService.update(id, values);

      dispatch({
        type: apiKeyFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.apiKey.update.success'),
      );

      getHistory().push('/api-key');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: apiKeyFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default apiKeyFormActions;
